import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';
import './global.scss'
import axios from 'axios';

function RedirectGBP() {
    const [searchParams] = useSearchParams();
    const [isLoading,setIsLoading] = useState(false)
    const navigate = useNavigate()
    useEffect(()=>{
        handleRedirect();      
    // eslint-disable-next-line
    },[])
  // Extract the parameters
  
  const handleRedirect = async ()=>{
      setIsLoading(true)
    //   const institution = searchParams.get('institution');
    //   const consentId = searchParams.get('consentid');
    //   const userUuid = searchParams.get('user-uuid');
    //   const applicationUserId = searchParams.get('application-user-id');
      const paymentRequestId = searchParams.get('paymentRequestId');
     
    try{

        if(paymentRequestId){

            let data ={
                paymentRequestId:paymentRequestId
            }
            const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/europe/transfer-status"
            const res = await axios.post(url,data)
            console.log("status: ",res.data)
            setIsLoading(false)
            // const {status} = res.data.data.data
            const status = res.data?.data.data?.payments[0]["paymentStatus"];
            const result = res.data
            if(status==="COMPLETED"){
                navigate('/pages/success',{ state: { result } })
                // console.log("status: ",status)
            }else if(status === "FAILED"){
                navigate('/pages/failed',{ state: { result } })
            }else if(status === "PENDING"){
                navigate('/pages/payment-pending',{ state: { result } })
            } else {
                navigate('/pages/failed',{ state: { result } })
            }
           
        }else{
            navigate('/invalid')
        }
       


        // console.log("response Data: ",res.data);
        
    }catch(err){
        setIsLoading(false)
        console.log(err);
        navigate('/pages/failed')
    }

  }
  return (
    <div className="loader">
          <div className='loading_overlay' style={{background:"#e9e9e9"}}>
             
                {
                    isLoading &&
                    <FadeLoader
                    cssOverride={{marginRight:"auto",marginLeft:"auto"}}
                    color="#259792"
                    />
                }
              
          </div>
   </div>
  )
}

export default RedirectGBP